import clsx from "clsx";
import { ProgressExpandButton } from "./ProgressStandardExpandButton";
import { SubStandard } from "../../../manager/components/standards/common/types";

export const ProgressStandardRow = ({
  id,
  depth,
  standard,
  path,
  isActive,
  expanded,
  onClick,
}: {
  id: string;
  depth: number;
  standard: SubStandard;
  path: string;
  isActive: boolean;
  expanded: boolean;
  onClick: () => void;
}) => {
  const RowHeader = depth === 1 ? "h4" : "h5";

  return (
    <div
      className={clsx(
        "flex justify-between border bg-white align-middle",
        depth === 1 && "mt-2 rounded-t px-8 py-4 text-sm font-semibold",
        depth === 2 && "border-t-0 py-4 pr-8",
        depth > 2 && "border-t-0 py-4 pr-8"
      )}
      onClick={onClick}
    >
      <RowHeader
        id={id}
        className={clsx(
          "standard-descrip",
          getNewPadding(depth),
          depth === 1 ? "text-center align-middle" : "text-sm",
          "group relative",
          depth === 2 && "hover:underline",
          depth > 2 && "hover:underline"
        )}
      >
        {(Array.isArray(standard.module_data) ||
          (standard && typeof standard.data === "undefined")) && (
          <input
            type="checkbox"
            name="select-standard"
            value={path}
            style={{ position: "absolute" }}
            className={clsx(
              "custom-checkbox",
              getCheckboxPosition(depth),
              "absolute m-1 outline-1 hover:cursor-pointer disabled:hover:cursor-not-allowed"
            )}
            checked={isActive}
            readOnly
            disabled={isCheckboxDisabled(standard)}
          />
        )}
        <span
          className={clsx(
            isCheckboxDisabled(standard)
              ? "pointer-events-none text-dm-gray-200"
              : "bg-white"
          )}
        >
          {depth > 1 && (
            <span className="text-1xl dm-dark-blue mb-0 mr-1 mt-0 inline-block font-semibold leading-relaxed">
              {printLabel(standard.label, depth)}
            </span>
          )}
          <span className="leading-relaxed">
            {printDescription(standard.description)}
          </span>
        </span>
        {isCheckboxDisabled(standard) && (
          <div className="invisible absolute -top-10 ml-8 items-center text-left group-hover:visible">
            <span className="whitespace-no-wrap relative z-10 block bg-black p-2 text-xs text-white shadow-lg">
              No skills on DeltaMath yet align to this standard.
            </span>
            <div className="align-center -my-2 mx-auto h-3 w-3 rotate-45 bg-black"></div>
          </div>
        )}
      </RowHeader>
      <div>
        {!(
          standard.module_data ||
          (standard && typeof standard.data === "undefined")
        ) && <ProgressExpandButton isExpanded={expanded} />}
      </div>
    </div>
  );
};

const printLabel = (label: string | undefined, depth: number) => {
  if (label && [".", ":"].includes(label[label.length - 1])) {
    label = label.slice(0, -1);
  }
  if (depth === 2) return label ? " (" + label + ")" : "";
  else if ([3, 4, 5, 6].includes(depth)) {
    if (label && label.trim() === label) return label + ":";
    if (label && label.trim() !== label) return "\u2022"; // Bullet Point
    return "";
  }
};

const printDescription = (description: string | undefined) => {
  if (!description) return "";
  return description.replace(/\(([^)]*)\)$[^(]*$/, "");
};

const getNewPadding = (depth: number) => {
  if (depth === 2) return "pl-16";
  if (depth === 3) return "pl-24";
  if (depth === 4) return "pl-32";
  else if (depth === 5) return "pl-40";
  else if (depth === 6) return "pl-48";
  else return "";
};

const getCheckboxPosition = (depth: number) => {
  if (depth === 2) return "left-8";
  if (depth === 3) return "left-16";
  if (depth === 4) return "left-24";
  else if (depth === 5) return "left-32";
  else if (depth === 6) return "left-40";
  else return "";
};

const isCheckboxDisabled = (standard: SubStandard) => {
  return (
    (standard.module_data && standard.module_data.length === 0) ||
    (standard &&
      typeof standard.data === "undefined" &&
      typeof standard.module_data === "undefined")
  );
};
